import React from 'react';
import styled from 'styled-components';

// RenderedProp is used to create a styled component passed in as a render prop.
// This was done to enable React Router `Link` components
const RenderedProp = styled(({ render, ...props }) => React.cloneElement(render, props))``;

export default RenderedProp;
